import * as React from 'react';
import { observer } from 'mobx-react';
import { colorBrand, colorWhite } from '../theme/color';
import { px } from 'csx';
import { classes, style } from 'typestyle';
import { Logo } from './logo';
import { vertical } from 'csstips';
import { mediaMobileOnly } from '../theme/media';
import { CopyBox } from './copy-box';
import { resetAnchorStyles } from '../theme/reset';
import {LicenceSchema} from '../types/schema';
import {videoAttribution} from '../lib/string';
import {formatCurrency} from '../lib/currency';
import MainWrapper from './main-wrapper';

export interface PageAttributionModel {
  licence: LicenceSchema;
  referralUrl: string;
}

export interface PageAttributionProps {
  model: PageAttributionModel;
  i18n?: {
    title: string;
    strap: string;
    why: string;
  }
}

const constants = {
  maxWidth: px(670)
};

@observer
export class PageAttribution extends React.Component<PageAttributionProps, any> {
  render() {
    const { model, i18n = PageAttribution.i18n } = this.props;

    const content = videoAttribution(model.licence, model.referralUrl);

    return (
      <MainWrapper>
        <header className={classes(PageAttribution.styles.header, PageAttribution.styles.padMobile)}>
          <h1><Logo /></h1>
          <h2>{i18n.title}</h2>
          <div>Track {model.licence.track.title} by {model.licence.track.artists.map(artist => artist.name).join(', ')}</div>
          <div>for {model.licence.order.youtube_channels.map(channel => `"${channel.name}"`).join(', ')}</div>
          <div>Paid {formatCurrency(model.licence.amount, model.licence.order.locale.currency)} for {model.licence.rate_card_name} average video viewership</div>
        </header>
        <main className={classes(PageAttribution.styles.main, PageAttribution.styles.padMobile)}>
          <div>
            <h3>{i18n.title}</h3>
            <p>{i18n.strap} <a target="_blank" href="/faq#why-do-i-need-to-credit-the-artist" className={PageAttribution.styles.link}>{i18n.why}</a></p>
            <CopyBox content={content} />
          </div>
        </main>
      </MainWrapper>
    )
  }

  static i18n = {
    title: 'Video description attribution',
    strap: 'Please copy the following into your YouTube video description.',
    why: 'Why do I have to do this?',
  };

  static styles = {
    header: style({
      background: colorBrand.toString(),
      color: colorWhite.toString(),
      padding: '60px 0 30px 0',
      $nest: {
        '&> *': {
          maxWidth: constants.maxWidth,
          marginLeft: 'auto',
          marginRight: 'auto',
        },
        '&> h1': {
          marginTop: 0,
          marginBottom: 0,
          fontSize: px(60),
          letterSpacing: px(-1)
        },
        '&> h2': {
          marginTop: px(20),
          marginBottom: px(60),
          fontSize: px(46),
          letterSpacing: px(-1),
          transform: 'translate3d(-3px, 0, 0)'
        },
        '&> div': {
          fontSize: px(20),
          marginTop: px(10)
        }
      }
    }),
    main: style({
      ...vertical,
      maxWidth: constants.maxWidth,
      margin: '0 auto 60px',
      pageBreakAfter: 'always',
      $nest: {
        '&> *': {
          flex: 1
        },
        '& h3': {
          margin: '30px 0 10px'
        },
        '& ul': {
          margin: 0,
          padding: 0,
          listStyle: 'none inside none'
        },
        '&> p': {
          margin: '0 0 30px 0'
        }
      }
    }),
    link: style({
      color: colorBrand.toString(),
      $nest: { ...resetAnchorStyles(colorBrand.toString()) }
    }),
    padMobile: style(
      mediaMobileOnly({
        paddingLeft: px(20),
        paddingRight: px(20)
      })
    )
  }
}